import { Divider } from '@advanza/ui'
import LostInvoicesList from 'components/billing/LostInvoicesList'
import Page from 'components/ui/Page'
import React from 'react'

const LostInvoicesPage = ({ filterId = 'lost' }) => {
    return (
        <Page>
            <Divider l />
            <LostInvoicesList filterId={filterId} />
        </Page>
    )
}

export default LostInvoicesPage
